module.exports = __webpack_public_path__ + "static/media/strength.f48a8895.jpg";